import { validateTidalLicense } from "../../base/index.js";
validateTidalLicense();
function expandHexColor(color) {
  const hex = color.trim().replaceAll(/[^a-fA-F0-9]/g, "");
  if (hex.length === 8) {
    return `#${hex}`;
  }
  if (hex.length === 6) {
    return `#${hex}ff`;
  }
  if (hex.length === 3 || hex.length === 4) {
    const r = hex.charAt(0).repeat(2);
    const g = hex.charAt(1).repeat(2);
    const b = hex.charAt(2).repeat(2);
    const a = (hex.charAt(3) || "f").repeat(2);
    return `#${r}${g}${b}${a}`;
  }
}
export {
  expandHexColor
};
//# sourceMappingURL=expandHexColor.js.map
